import { faPencil } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { UnstyledButton } from '@mantine/core'
import React from 'react'

interface PencilEditButtonProps {
  onClick: () => void
  style?: React.CSSProperties
  className?: string
}

function PencilEditButton(props: PencilEditButtonProps) {
  const { onClick, className } = props
  return (
    <UnstyledButton onClick={onClick} style={props.style} className={className}>
      <FontAwesomeIcon icon={faPencil} size='sm' />
    </UnstyledButton>
  )
}

export default PencilEditButton
